import { combineReducers } from '@reduxjs/toolkit'
import { reducer as user } from './user'
import { reducer as company } from './company'
import { reducer as sites } from './sites'
import { reducer as metadata } from './metadata'

export const rootReducer = combineReducers({
    user,
    company,
    sites,
    metadata,
})

export type RootState = ReturnType<typeof rootReducer>
